<template>
  <!-- Footer -->
  <div
    class="bg-surface-50 mt-auto h-full w-full flex-col items-end justify-center p-4 px-8 text-sm backdrop-blur"
  >
    <div class="flex w-full justify-end">
      <SocialLinksRow size="sm" class="mb-4" />
    </div>

    <div
      class="flex w-full flex-wrap-reverse items-center justify-between gap-x-10 gap-y-2 text-nowrap"
    >
      <div class="flex items-center gap-4">
        <span class="opacity-80">Copyright © 2025 Scan The World</span>
        <!-- Dev dashboard - same line, left side of copyright -->
        <FooterDevDashboard />
      </div>

      <div class="flex gap-3 font-medium">
        <a
          class="hover:text-primary cursor-pointer transition-colors duration-200"
          @click="handleContactUs"
        >
          Contact Us
        </a>
        <router-link
          to="/privacy-policy"
          class="hover:text-primary transition-colors duration-200"
        >
          Privacy Policy
        </router-link>
        <router-link
          to="/eula"
          class="hover:text-primary transition-colors duration-200"
        >
          Terms of Service
        </router-link>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useRouter } from 'vue-router';

import FooterDevDashboard from '@/components/_dev/FooterDevDashboard.vue';
import SocialLinksRow from '@/components/SocialLinksRow.vue';

const router = useRouter();

const handleContactUs = () => {
  router.push('/contact');
};
</script>
